import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTranslation } from "react-i18next";
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/he';

const CrmDateRange = ({
  name,
  label,
  value,
  onChange,
  type = 'date',// 'date' | 'datetime'
  required,
}) => {
  const [t] = useTranslation('crm');

  // Parse existing value if it's a range object
  const parseValue = () => {
    if (!value) return { from: null, to: null };
    if (typeof value === 'object' && (value.from || value.to)) {
      return {
        from: value.from ? dayjs(value.from) : null,
        to: value.to ? dayjs(value.to) : null
      };
    }
    // If it's a single date value, treat it as 'from'
    return {
      from: value ? dayjs(value) : null,
      to: null
    };
  };

  const { from, to } = parseValue();

  const handleFromChange = (newValue) => {
    const newRange = {
      from: newValue ? newValue.toISOString() : null,
      to: to ? to.toISOString() : null
    };
    onChange({ target: { name, value: newRange, type } });
  };

  const handleToChange = (newValue) => {
    const newRange = {
      from: from ? from.toISOString() : null,
      to: newValue ? newValue.toISOString() : null
    };
    onChange({ target: { name, value: newRange, type } });
  };

  const commonProps = {
    format: type === 'datetime' ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY',
    slotProps: {
      textField: {
        fullWidth: true,
        size: 'small',
        required: false, // Don't make individual fields required
      },
      actionBar: {
        actions: ['today', 'clear', 'accept'],
      },
    },
  };

  const PickerComponent = type === 'datetime' ? DateTimePicker : DatePicker;
  const pickerProps = type === 'datetime' ? { ampm: false, closeOnSelect: false } : {};

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="he"
      localeText={{
        okButtonLabel: t('Accept'),
        clearButtonLabel: t('Clear'),
        todayButtonLabel: t('Now'),
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, width: '100%' }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <PickerComponent
            {...commonProps}
            {...pickerProps}
            label={`${label} - ${t('From')}`}
            value={from}
            onChange={handleFromChange}
            maxDate={to || undefined}
          />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <PickerComponent
            {...commonProps}
            {...pickerProps}
            label={`${label} - ${t('To')}`}
            value={to}
            onChange={handleToChange}
            minDate={from || undefined}
          />
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default CrmDateRange;